module.exports = __webpack_public_path__ + "img/ic-visacard.8d45baea.svg";